import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders, HttpParams } from '@angular/common/http';
import { GlobalVariable } from 'app/main/globals';

@Injectable({
  providedIn: 'root'
})
export class AspInvoiceDetailsService {

  constructor(
    private http: HttpClient,

  ) { }
  
  invoiceDetails(invoiceId,jobcardId,garageKey){
    let paramData = {  
      invoiceId: invoiceId,
      jobcardId:jobcardId,
      garageKey:garageKey
  };
    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}` + '/garageManagement/v1/getInvoice', paramData);
    }
  submitDataUpdate(payload: any){
    const paramData=payload;
    
    console.log('-----submitDataUpdate-----------');    
    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}/garageManagement/v1/updateInvoice`, paramData);
  
  }
  confirmInvoice(payload: any){
    const paramData=payload;
    
    console.log('-----ConfirmStatus-----------');    
    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}/garageManagement/v1/invoice/confirm`, paramData);
  
  }
  showGst(payload: any){
    const paramData=payload;
    
    console.log('-----Show Gst-----------');    
    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}/garageManagement/v1/invoice/setGst`, paramData);
  
  }
  searchB2BLineItem(searchTerm: string) {
      const spareGarageId = localStorage.getItem('spareGarageId');
    
      const sessionPost = {
        spareGarageId: spareGarageId,
        userType: 'pitstopspare',
        search: searchTerm,
        type: ''
      };
    
      const headers = new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      });
    
      const body = new HttpParams()
        .set('sessionPost', JSON.stringify(sessionPost));
    
      return this.http.post(`${GlobalVariable.BASE_API_URL}/pitstop/b2bsearchlineitem`, body, { headers });
    }
}

